import styled from "styled-components";

import { Table } from "commons";

export const FolioTable = styled(Table)`
    table-layout: auto;
    margin-bottom: 0;

    tr {
        border-bottom: 1px solid rgb(245, 244, 242);
    }

    td {
        padding: ${props => (props.dense ? "5px" : "0px")};
        height: ${props => (props.dense ? "auto" : "3rem")};
    }

    tr:last-of-type {
        border-bottom: 0;
    }

    @media print {
        th {
            padding: 0.5rem 0.5rem 0 0.2rem;
        }
    }
`;
